import Image from "next/image";
import CommonImage from "@/components/common/image/CommonImage";
import { LuClock5 } from "react-icons/lu";
import { FaStar } from "react-icons/fa";
import { FaCirclePlay } from "react-icons/fa6";
import Link from "next/link";
import CourseVideoModal from "../Modal/CourseVideoModal";
import { useState } from "react";

export default function CourseCard({ course, bgClass }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  return (
    <div className={`course-item ${bgClass}`}>
      <div className="course-image">
        {/* <CommonImage
          src={course?.thumbnail_url ?? "/images/course/thumbnail-1.avif"}
          className="thumbnail !h-full"
          alt="Course Thumbnail"
        /> */}
        <Image
          src={course?.thumbnail ?? "/images/course/thumbnail-1.avif"}
          alt="Course Thumbnail"
          className="arrow-icon w-full h-full"
          width={0}
          height={0}
          sizes="100vw"
        />

        <div className="course-card-playbtn">
          <a onClick={showModal} className="play-btn">
            <FaCirclePlay className="play-icon" />
          </a>
        </div>
      </div>

      <div className="item-content">
        <h4 className="title">
          {" "}
          {course?.title?.length > 60
            ? `${course.title.slice(0, 60)}...`
            : course?.title}
        </h4>

        <ul className="course-card-dt-list">
          {/* <p  dangerouslySetInnerHTML={{__html:course?.short_description}}></p> */}

          <li className="dt-list">
            <span className="icon">
              <FaStar />
            </span>{" "}
            <span className="text">
              মোট ক্লাস সংখ্যা : {course?.total_class}+
            </span>
          </li>
          <li className="dt-list">
            <span className="icon">
              <FaStar />
            </span>{" "}
            <span className="text">
              প্রিন্টেড লেকচার শীট : {course?.printed_lecture_sheet} টি
            </span>
          </li>
          <li className="dt-list">
            <span className="icon">
              <FaStar />
            </span>{" "}
            <span className="text">
              মোট পরীক্ষার সংখ্যা : {course?.total_exam}+
            </span>
          </li>
        </ul>
        <div className="price-wrap">
          {(course?.type === "Online" ||
            course?.type === "Online & Offline") && (
               <div className="price-item">
              <h3 className="price-system">অনলাইনঃ</h3>
              <p className="price">
                <span className="main-price">
                  {course?.discount > 0
                    ? course?.online_admission_fee - (course?.discount || 0)
                    : course?.online_admission_fee ?? 0}{" "}
                  ৳
                </span>
                {course?.discount ? (
                  <span className="discount-price">
                    {course.online_admission_fee}৳
                  </span>
                ) : null}
              </p>
            </div>

              
           

          )}
          
          {(course?.type === "Offline" ||
            course?.type === "Online & Offline") && (

            <div className="price-item">
              <h3 className="price-system">অফলাইনঃ</h3>
              <p className="price">
                <span className="main-price">
                  {course?.discount > 0
                    ? course?.admission_fee - (course?.discount || 0)
                    : course?.admission_fee}{" "}
                  ৳
                </span>
                {course?.discount ? (
                  <span className="discount-price">
                    {course.admission_fee}৳
                  </span>
                ) : null}{" "}
              </p>
            </div>

          )}
        </div>

        <div className="course-card-btn-wrap">
          <Link href={`/course/${course?.slug}`} className="primary-btn">
            বিস্তারিত দেখুন
            <Image
              src={"/images/admission-icon/arrow-left.png"}
              alt="Arrow Right"
              className="arrow-icon"
              width={16}
              height={16}
            />
          </Link>
          <Link href={`/course/${course?.slug}`} className="secondary-btn">
            এনরোল করুন
            <Image
              src={"/images/admission-icon/arrow-left.png"}
              alt="Arrow Right"
              className="arrow-icon"
              width={16}
              height={16}
            />
          </Link>
        </div>
      </div>
      <CourseVideoModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        course={course}
      />
    </div>
  );
}
